"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
var validatorjs_1 = __importDefault(require("validatorjs"));
var messages_1 = require("./messages");
exports.validator = {
    isValid: function (data, rules) {
        var validation = new validatorjs_1.default(data, rules);
        return !!validation.passes();
    },
    validateAll: function (data, rules, messages) {
        if (messages === void 0) { messages = {}; }
        var validation = new validatorjs_1.default(data, rules, __assign(__assign({}, messages_1.messages), messages));
        // Transform and return errors
        if (validation.check() === false) {
            return Object.keys(validation.errors.all()).reduce(function (errors, key) {
                if (validation.errors.has(key)) {
                    errors[key] = validation.errors.first(key);
                }
                return errors;
            }, {});
        }
        else {
            return {};
        }
    },
};
